"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gl2ContextAdapter = void 0;
const gl_context_adapter_1 = require("./gl-context-adapter");
/**
 * @public
 * Webgl2 context adapter. Handles viewport and context loss.
 */
class Gl2ContextAdapter extends gl_context_adapter_1.GlContextAdapter {
    constructor(canvasElement, eventService, options) {
        super(canvasElement, eventService, "webgl2", options);
    }
}
exports.Gl2ContextAdapter = Gl2ContextAdapter;
//# sourceMappingURL=gl2-context-adapter.js.map